import axios from "axios";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Container, Form } from "react-bootstrap";
import Swal from "sweetalert2";

const DashboardModalAffiliateCode = (props) => {
  const { refetch, editingCode } = props;
  const [loading, setLoading] = useState(false);
  const AdminToken = localStorage.getItem("AiAdmin");
  const [formData, setFormData] = useState({ code: "", credit: "" });

  useEffect(() => {
    if (editingCode) {
      setFormData({
        code: editingCode.code || "",
        credit: editingCode.credit || "",
      });
    } else {
      setFormData({ code: "", credit: "" });
    }
  }, [editingCode, props.show]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    
    try {
      if (editingCode) {
        // Edit existing code
        const res = await axios.patch(
          `https://backend.whalesai.com/api/v1/affiliate-code/${editingCode._id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${AdminToken}`,
            },
          }
        );
        if (res.status === 200 || res.status === 201) {
          props.onHide();
          refetch();
          Swal.fire({
            text: "Affiliate code updated successfully.",
            icon: "success",
            background: "#011225",
            customClass: "modal_class_success",
          });
        }
      } else {
        // Add new code
        const res = await axios.post(
          "https://backend.whalesai.com/api/v1/affiliate-code",
          formData,
          {
            headers: {
              Authorization: `Bearer ${AdminToken}`,
            },
          }
        );
        if (res.status === 200 || res.status === 201) {
          props.onHide();
          refetch();
          Swal.fire({
            text: "Affiliate code created successfully.",
            icon: "success",
            background: "#011225",
            customClass: "modal_class_success",
          });
        }
      }
    } catch (error) {
      props.onHide();
      Swal.fire({
        text: error?.response?.data?.message || "An error occurred.",
        icon: "error",
        background: "#011225",
        customClass: "modal_class_success",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal {...props} centered style={{ zIndex: 1000000 }}>
      <Modal.Header closeButton>
        <Modal.Title>
          {editingCode ? "EDIT AFFILIATE CODE" : "ADD AFFILIATE CODE"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#303651", color: "white" }}>
        <Container>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="code" className="mb-3">
              <Form.Label>Code</Form.Label>
              <Form.Control
                placeholder="Enter affiliate code"
                type="text"
                name="code"
                value={formData.code}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="credit" className="mb-3">
              <Form.Label>Credit Amount</Form.Label>
              <Form.Control
                placeholder="Enter credit amount"
                type="number"
                name="credit"
                value={formData.credit}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="secondary" onClick={props.onHide}>
                Cancel
              </Button>
              <Button type="submit" variant="primary" disabled={loading}>
                {loading ? "Processing..." : (editingCode ? "Update" : "Add")}
              </Button>
            </Modal.Footer>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default DashboardModalAffiliateCode;
